export const header = {
  margin: ".5em 0 .5em",
  fontSize: "1em",
  lineHeight: "1em",
  color: "rgba(0,0,0,.6)",
};

export const styles = {
  header: {
    color: "#000000",
    fontWeight: "normal",
    fontSize: 18,
  },
  metaItems: {
    color: "#000000",
  },
  extraItems:{
    color:"rgba(0,0,0,0.7)"
  }
};

